import { atom } from 'jotai';

export type SnackbarSeverity = 'success' | 'error' | 'warning' | 'info';

// 通知に付与できる任意アクション。指す先は既存アクション（route 遷移・再クリック等価）に限定する。
export type SnackbarAction = {
    label: string;
    onClick: () => void;
};

export type SnackbarItem = {
    id: number;
    message: string;
    severity: SnackbarSeverity;
    action?: SnackbarAction;
};

// 通知キュー。useSnackbar の show* が push し、表示層（SnackbarStack）が積み重ねて表示する。
// 単発 state から queue へ reshape したが、公開 hook（useSnackbar の show*）の
// シグネチャと観測挙動（show* → トースト表示）は後方互換を維持する。
export const snackbarQueueAtom = atom<SnackbarItem[]>([]);
